import { render, staticRenderFns } from "./SelectRemotePublisherGroup.vue?vue&type=template&id=dd48a8d4&lang=pug&"
import script from "./SelectRemotePublisherGroup.vue?vue&type=script&lang=js&"
export * from "./SelectRemotePublisherGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports